<template>
  <div class="profile">
    <v-container>
      <v-card>
        <v-card-title class>Access rights</v-card-title>
        <v-card-text>
          <template v-for="[orga, rights] of Object.entries(userRights)">
            <div :key="orga">
              <v-divider></v-divider>
              <v-row class="ml-1 mt-2">
                <v-icon small color="red accent-2">mdi-home</v-icon>
                <span class="ml-1 text-h6 red--text text--accent-2">{{
                  orga.toUpperCase()
                }}</span>
              </v-row>
              <v-row>
                <v-col v-if="'locations' in rights" cols="12" sm="6">
                  <div class="text-subtitle-1">Locations:</div>
                  <div v-for="loc in rights.locations" :key="loc">
                    -
                    {{
                      findElement(loc, locations)
                        ? findElement(loc, locations).id
                        : ""
                    }}
                  </div>
                </v-col>
                <v-col v-if="'concepts' in rights" cols="12" sm="6">
                  <div class="text-subtitle-1">Concepts:</div>
                  <div v-for="c in rights.concepts" :key="c">
                    -
                    {{
                      findElement(c, concepts)
                        ? findElement(c, concepts).label
                        : ""
                    }}
                  </div>
                </v-col>
              </v-row>
            </div>
          </template>
        </v-card-text>
        <v-card-actions>
          <div class="caption">
            If you do not have an acces to concept/location, please contact your
            manager.
          </div>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  data: () => {
    return {};
  },
  computed: {
    ...mapState({
      locations: (state) => state.restaurant.locations,
      concepts: (state) => state.restaurant.concepts,
    }),
    userRights() {
      let res = {};
      for (let [orga, locs] of Object.entries(this.userLocations)) {
        if (!(orga in res)) {
          res[orga] = {};
        }
        res[orga]["locations"] = new Set(locs);
      }
      for (let [orga, concepts] of Object.entries(this.userConcepts)) {
        if (!(orga in res)) {
          res[orga] = {};
        }
        res[orga]["concepts"] = concepts;
      }
      return res;
    },
    userLocations() {
      let groups = this.$auth.groups;
      return this.getRigths(groups, "locations");
    },
    userConcepts() {
      let groups = this.$auth.groups;
      return this.getRigths(groups, "concepts");
    },
  },
  methods: {
    ...mapActions({
      setError: "setError",
    }),
    ...mapActions("restaurant", {
      fetchAllConcepts: "fetchAllConcepts",
      fetchAllLocations: "fetchAllLocations",
    }),
    getRigths(groups, right) {
      let reg = new RegExp(`/(.+?)/rights/${right}/(.*?)/(.*?)[^/]$`);
      let matched = groups.filter((group) => {
        return group.match(reg);
      });
      let res = {};
      matched.forEach((group) => {
        let splitted = group.split("/");
        let orga = splitted[1];
        let uuid = splitted[splitted.length - 1];
        if (!(orga in res)) {
          res[orga] = [];
        }
        res[orga].push(uuid);
      });
      return res;
    },
    refresh() {
      this.fetchAllConcepts().catch((error) => {
        this.setError(error);
      });
      this.fetchAllLocations().catch((error) => {
        this.setError(error);
      });
    },
    findElement(uuid, list) {
      return list.find((el) => el.uuid === uuid);
    },
  },
  created() {
    this.refresh();
  },
};
</script>
